/*
 * laravel-echo + pusher-js are ~99 KB minified, and the only thing on the site
 * that speaks to a channel is components/Notifications.vue — which the header
 * renders for signed-in visitors only. So neither library is imported here:
 * they are pulled in on demand, which keeps them in their own chunk instead of
 * riding along in vendor.js on every page a guest opens.
 *
 * initEcho() is memoised and returns a promise. Await it before touching
 * window.Echo; the imports mean it is not there on the same tick any more.
 */

let echoPromise = null

export function initEcho() {
	if (echoPromise) return echoPromise

	echoPromise = Promise.all([
		import('laravel-echo'),
		import('pusher-js'),
	]).then(([{ default: Echo }, { default: Pusher }]) => {
		window.Pusher = Pusher
		window.Echo = new Echo({
			broadcaster: 'pusher',
			key: process.env.MIX_PUSHER_APP_KEY,
			cluster: process.env.MIX_PUSHER_APP_CLUSTER,
			wsHost: process.env.MIX_PUSHER_HOST,
			wsPort: process.env.MIX_PUSHER_PORT,
			wssPort: process.env.MIX_PUSHER_PORT,
			forceTLS: false,
			encrypted: process.env.MIX_PUSHER_ENCRYPTED,
			disableStats: true,
			enabledTransports: ['ws', 'wss'],
			authorizer: (channel, options) => {
				return {
					authorize: (socketId, callback) => {
						fetch(process.env.MIX_ENDLESS_API_BASE_URL + '/broadcasting/auth', {
							method: 'POST',
							headers: {
								'Content-Type': 'application/json',
								'Accept': 'application/json',
								// Read at auth time: the token may not be in
								// localStorage yet when this module loads.
								Authorization: 'Bearer ' + localStorage.getItem('api-token'),
							},
							body: JSON.stringify({
								socket_id: socketId,
								channel_name: channel.name,
							}),
						})
							.then((response) => response.json())
							.then((response) => {
								callback(null, response)
							})
							.catch((error) => {
								callback(error)
							})
					},
				}
			},
		})
		return window.Echo
	})

	return echoPromise
}
